module.exports = __webpack_public_path__ + "img/6.ed85fa4b.png";